// extracted by mini-css-extract-plugin
export default {"Author":"Author_Author__ODhmN","AuthorImage":"Author_AuthorImage__ZWQwY"};